export default {
  'AI Face Animator': 'AI gezichtsanimator',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'Maak ongelooflijke gezichtsuitdrukkingen met hersenspoelmuziek, vind de magie voor uw plezier.',
  'Upload a photo': 'Upload een foto',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': "Opmerking: zorg ervoor dat het gezicht op de foto's die u gekozen hebt naar de lens gericht is, anders kunnen ze niet met succes verwerkt worden.",
  'Uploaded successfully!': 'Succesvol geüpload!',
  'Please select a template below': 'Kies hieronder een sjabloon',
  'Choose a GIF': 'Kies een GIF',
  'Use this template': 'Gebruik deze sjabloon',
  'Verify successfully! You will': 'Verifieer met succes! U zult de video met {{email}} spoedig ontvangen.',
  'You will': 'U zult de video met {{email}} spoedig ontvangen.',
  'What you should expect to happen next': 'Wat u daarna mag verwachten:',
  'We will process your photo into a dynamic video.': 'Wij verwerken uw foto tot een dynamische video.',
  'After processing, we will send the video to your email.': 'Na verwerking sturen wij de video naar uw e-mail.',
  'You can check the video in your email.': 'U kunt de video in uw e-mail bekijken.',
  'Your video will be delivered via email': 'Uw video wordt via e-mail bezorgd',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': "Het duurt 20-30 minuten om een dynamische video samen te stellen, dus even geduld a.u.b. Om uw privacy te beschermen worden de geüploade foto's automatisch gewist als de verwerking voorbij is.",
  'Your Email': 'Uw e-mail',
  'Last Name': 'Eerste naam',
  'First Name': 'Uw achternaam',
  'Go back': 'Ga terug',
  'Invalid email address':'Ongeldig e-mailadres',
  'Enter verification code':'Verificatiecode invoeren',
  'Enter the verification code that we sent to': 'Voer de verificatiecode in die wij naar {{email}} hebben gestuurd.',
  'Resend': 'Opnieuw verzenden',
  'Verification code': 'Verificatie code',
  'Resend after': 'Opnieuw verzenden na {{num}}',
  'The verification code is invalid. You can request a new one.': 'De verificatiecode is ongeldig. U kunt een nieuwe aanvragen.',
  'Synthesize Video': 'Synthese video',
  'Too many attempts, please try again later.': '请求频繁，请稍后再试。',
}